import _ from "underscore"
import TreeNodeRenderer from "../tree/TreeNodeRenderer";

export default function SelectionTreeNodeRenderer(tree)
{
    TreeNodeRenderer.call( this, tree );
}

SelectionTreeNodeRenderer.prototype = _.create(TreeNodeRenderer.prototype);

SelectionTreeNodeRenderer.prototype.getNodeClasses = function ( treeNode )
{
    var classes = TreeNodeRenderer.prototype.getNodeClasses.call( this, treeNode );
    if( this.tree.getSelectionController().isSelected( treeNode ) )
        classes.push( "selected" );
    return classes;
};



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/selectionTree/SelectionTreeNodeRenderer.js